import { MessageDescriptor } from 'react-intl'

import { CMS_MICROSITE_MESSAGE } from './messages/messages'

import type { COMMON_MIXPANEL_EVENTS } from '../common/constants/mixpanelConstants'

export enum CMS_MICROSITE_ID {
  NEW_YEAR_TOOLKIT = 'NewYearToolkit',
  MAY_MENTAL_HEALTH = 'MayMentalHealthToolkit',
  NICOTINE_QUITLINE = 'NicotineQuitline',
  NEURODIVERSITY = 'NeurodiversityToolkit',
  COPING_WITH_STRESS = 'CopingWithStressToolkit',
  RELATIONSHIPS = 'RelationshipsToolkit',
  MOTIVATION = 'MotivationToolkit',
  FAMILY = 'FamilyToolkit',
  CIS_NATURAL_DISASTER = 'CisNaturalDisaster',
  CIS_POLITICAL_UNCERTAINTY = 'CisPoliticalUncertainty',
  CIS_GRIEF = 'CisGrief',
  CIS_INJUSTICE = 'CisInjustice',
  CIS_LOSS_OF_SAFETY = 'CisLossOfSafety',
  GOOGLE_PERFORMANCE = 'GooglePerformance',
  GOOGLE_OUS_COMING_SOON = 'GoogleOUSComingSoon',
  GRIEF = 'Grief',
  HOLIDAY_STRESS = 'HolidayStress',
  PAID_SOCIAL = 'PaidSocial',
  WORLD_MENTAL_HEALTH_DAY = 'WorldMentalHealthDay',
  PARENTAL_LEAVE_COACHING = 'ParentalLeaveCoaching',
  FINISH_YEAR_STRONG = 'FinishYearStrong',
  NEW_YEAR_2026 = 'NewYear2026Toolkit',
  ANXIETY = 'Anxiety',
  THRIVING_AT_WORK = 'ThrivingAtWork',
  RESOURCE_COORDINATOR = 'ResourceCoordinator',
  MANAGER_COACHING = 'ManagerCoaching',
  MENTAL_HEALTH_EVALUATIONS = 'MentalHealthEvaluations',
  MENTAL_HEALTH_EVALUATIONS_GLOBAL = 'MentalHealthEvaluationsGlobal',
  CONFIDENCE = 'Confidence',
  MENTAL_FITNESS = 'MentalFitness',
  ELECTION = 'Election',
}
export interface CMSMicrositeWithMetadataProps {
  micrositeMetadata: CMSMicrositeMetadata
  shouldShowLegalFooter?: boolean
}

/** Params for a `REGISTER_WEBINAR` post message event */
export interface CMSMicrositeWebinarParams {
  /** Essentials event slug. Required when a microsite has more than one webinar entry. */
  eventKey?: string
  webinarLink?: string
}

export interface CMSMicrositePostMessageEvent {
  key: CMS_MICROSITE_MESSAGE
  params?: CMSMicrositeWebinarParams & Dict
}

export interface CMSMicrositeMetadata {
  micrositeId: CMS_MICROSITE_ID
  micrositeUrl: string
  /** Should match the Base Directory url (exclude /secure) from the CMS */
  iFrameSrcUrl: string
  title: MessageDescriptor
  featureFlag?: string
  /** If any of the conditions are true, the microsite should be hidden */
  customerPropertyConditions: { key: string; value: boolean }[]
  /** Post messages that can be sent through the CMS, attached to ctas. See available events in CMS_MICROSITE_MESSAGE */
  postMessageEvents: CMSMicrositePostMessageEvent[]
  /** Mixpanel page string */
  page: string
  trackUTMParams?: { utm_campaign?: string; utm_source?: string; utm_medium?: string }
  /** Custom props that will be passed to all events */
  customMixpanelEventProps?: Dict
  shouldHideForInternational: boolean
  /** Used `page` from this interface in the mixpanel view event: `view ${page}` */
  usePageForViewEvent?: boolean
  /** When set, uses this value instead of `page` for the view event name: `view ${viewEventPage}` */
  viewEventPage?: string
  /** Track entry point from URL params, location state, previous routes, and UTM campaigns using useDefaultMixpanelEntryPoint hook */
  trackEntryPoint?: boolean
  /** Mixpanel event fired if the native microsite iframe fails to load */
  errorEvent?: COMMON_MIXPANEL_EVENTS
}

export enum CMS_MICROSITE_IFRAME_MESSAGES {
  SET_CUSTOM_MESSAGES = 'setCustomMessages',
  DOCUMENT_OBJECT = 'Document Object',
  IFRAME_READY = 'iframeReady',
  SET_FRESHPAINT_USER = 'setFreshpaintUser',
}
